import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

import { useQuotationDetail } from './hook';
import { QuotationRegisterHistory } from './registerHistory';
import { QuotationAccountInfo } from './accountInfo';
import { QuotationDetailGeneralInfo } from './generalInfo';
import { QuotationHistorical } from '../historical';

import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { RootState } from '../../../../../redux/store';
import { LayoutModule } from '../../../../layout/modules';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import { QUOTATION, QUOTATION_EDIT } from '../../../../../routes/paths';

export const QuotationDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [showHistorical, setShowHistorical] = useState(false);
    const { quotation, loading, quotationHistorical } =
        useQuotationDetail(showHistorical);
    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle cotizaciones"
                titleChildren="Detalle cuenta"
                icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                additionalButtons={
                    <ActionButtonGroup
                        id={quotation?.id || ''}
                        buttonSearch={{
                            show: true,
                            route: QUOTATION,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: QUOTATION_EDIT,
                        }}
                        buttonLog={{
                            show: true,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <QuotationHistorical
                            historical={quotationHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Proceso"
                    showTitle={false}
                    titleChildren="Cuenta"
                    icon={<PeopleAltIcon sx={{ color: 'primary.main' }} />}
                >
                    <QuotationAccountInfo
                        account={quotation?.account}
                        loading={loading}
                    />
                </LayoutModule>
            </LayoutModule>
            <QuotationRegisterHistory quotation={quotation} />
            <QuotationDetailGeneralInfo quotation={quotation} />
        </>
    );
};
